<template>
    <div class="my_product">
        <div class="search ">
            <el-form :inline="true" class="demo-form-inline " size="mini">
                <el-form-item :label="$t('编码/名称')">
                    <el-input v-model="search.keyword" size="mini"></el-input>
                </el-form-item>
                <el-form-item :label="$t('类别')">
                    <el-input v-model="search.categoryFirstSup" size="mini"></el-input>
                </el-form-item>
                <el-form-item :label="$t('适用车型')">
                    <el-input v-model="search.carTypeName" size="mini"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" size="mini">{{ $t('查询') }}</el-button>
                    <el-button @click="handleReset" size="mini">{{ $t('重置') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="danger" @click="del_num">{{ $t('批量删除') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-upload class="upload-demo" action="" :file-list="fileList" :http-request="Upload"
                        :show-file-list=false :on-success="handleSuccess">
                        <el-button size="mini" type="primary">{{ $t('上传') }}</el-button>
                    </el-upload>
                    <a class="ml-10 fs-10"
                        href="https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyhd756231ed2e9459ca3bb3d6ff7ea57df广园汇商品导入模板.xlsx">{{
                            $t('库存模板') }}</a>
                </el-form-item>
            </el-form>
        </div>

        <div class="table mt-10">
            <el-table v-loading="loading"  :data="my_productList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column :label="$t('商品编码')">
                    <template slot-scope="scope">
                        <p>{{ scope.row.partsNo }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('商品名称')" width="150px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.cname }}</p>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('商品类别')">
                    <template slot-scope="scope">
                        {{ scope.row.categoryFirstSup }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('适用车型')">
                    <template slot-scope="scope">
                        {{ scope.row.carTypeName }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('状态')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">{{ $t('未审核') }}</span>
                        <span v-else-if="scope.row.status == 2">{{ $t('审核通过') }}</span>
                        <span v-else-if="scope.row.status == 3">{{ $t('审核不通过') }}</span>
                        <span v-else>{{ $t('未知状态') }}</span> <!-- 如果状态值不在1、2、3中，显示“未知状态” -->
                    </template>
                </el-table-column>
                <el-table-column :label="$t('参考价格')">
                    <template slot-scope="scope">
                        {{ scope.row.batchPrice }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('库存')">
                    <template slot-scope="scope">
                        {{ scope.row.stock }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" width="180">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handledel(scope.$index, scope.row)">{{
                            $t('删除') }}</el-button>
                        <el-button v-if="scope.row.selling == 1" size="mini" type="danger"
                            @click="handlIsSell(scope.$index, scope.row)">{{ $t('下架') }}</el-button>
                        <el-button v-else size="mini" type="success" @click="handlIsSell(scope.$index, scope.row)">{{
                            $t('上架') }}</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination background :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                :page-size="search.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                @size-change="handleChangeSize" @current-change="handleSearch" />
        </div>
    </div>
</template>
<script>
import { getproductslist, IsSelling, delporduct, importExcel, importstate } from '../../../apis/my_product'
export default {
    data() {
        return {
            loading:true,
            search: {
                carTypeName: '',
                categoryFirstSup: '',
                keyword: '',
                pageSize: 10,
            },
            total: 0,
            currentPage: 1,
            pageSize: 10,
            pageCount: 0,
            my_productList: [],
            fileList: [],
            ids: []

        }
    },
    created() {
        this.productList()
    },
    methods: {
        async productList(body = {
            "carTypeName": '',
            "categoryFirstSup": '',
            "keyword": '',
            "pageSize": 10
        }) {
            // 我的活动
            const { current, records, size, total } = (await getproductslist(body)).data
            this.my_productList = records
            this.loading = false
            this.total = total
        },

        handleReset() {
            this.search.carTypeName = []
            this.search.categoryFirstSup = []
            this.search.keyword = []
            this.handleSearch();
        },
        onSubmit() {
            console.log(this.search)
            this.handleSearch();
        },
        // 查询数据
        handleSearch(currentPage = 1) {
            this.currentPage = currentPage;
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.search,
                    currentPage,
                },
            });
            this.productList({ ...this.search, currentPage });
        },
        // 分页
        handleChangeSize(value) {
            this.pageSize = value;
            this.search.pageSize = value;
            this.handleSearch();
        },
        // 上下架
        async handlIsSell(index, event) {
            const { selling, id } = event;
            const data = {
                ids: [id],
                status: selling === '0' ? '1' : '0'
            }
            try {
                await IsSelling(data)
                this.$message({
                    message: selling === '0' ? this.$t('上架成功') : this.$t('下架成功'),
                    type: 'success'
                });
                this.productList()
            } catch (e) {
                this.$message({
                    message: e,
                    type: 'error'
                });
            }


        },
        // 删除
        async handledel(index, event) {
            this.loading = true;
            const { id } = event;
            const data = {
                ids: [id],
            }
            try {
                await delporduct(data);
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loading = false;
                this.productList()
            } catch (e) {
                this.$message({
                    message: e,
                    type: 'error'
                });
            }




        },
        // 文件上传
        async Upload({ file, onSuccess, onError }) {
            this.loading =true;
            const newData = {
                file: file
            }
            try {
                  // 等待 importExcel 异步函数执行完毕
                const { data } = await importExcel(newData);
                // 等待 IsImport 异步函数执行完毕
                await this.IsImport(data);
              
        
               
            }
            catch (e) {
                this.$message.error(e)
            }


        },
        // 上传文件成功回调函数
        async handleSuccess() {
            // const  res = await importstate(file.uid)
            this.handleSearch()
        },

        // 检查上传文件状态
        async IsImport(id) {
            const {data} = await importstate(id);
            if (data.length === 0) {
               await new Promise(resolve => setTimeout(() => resolve(this.IsImport(id)), 5000));
            } else {
                // 根据 data.type 处理不同的状态
                switch (data[0].type) {
                    case '0':
                        this.$message.error(this.$t('上传失败'));
                        break;
                    case '1':
                        this.$message(this.$t('上传中请等待'));
                        await IsImport(id);
                        break;
                    case '2':
                        this.$message({ message: '上传成功', type: 'success' });
                        break; 
                    case '3':
                        this.$message({ message: '部分上传成功', type: 'warning' });
                        break;
                    default:
                        this.$message({ message: '未知状态', type: 'info' });
                        break;
                }
            }
        },

        // 多选
        handleSelectionChange(val) {
            this.ids = val.map(item => (item.id))

        },
        async del_num() {
            try {
                const data = {
                    ids: this.ids,
                }
                await delporduct(data);
                this.$message({
                    message: this.$t('删除成功'),
                    type: 'success'
                });
                this.productList()
            } catch (e) {
                this.$message({
                    message: e,
                    type: 'error'
                });
            }
        },


    }
}
</script>
<style>
.my_product {
    padding: 20px 10px;
}
</style>
